/* eslint-disable no-template-curly-in-string */
/* eslint-disable eqeqeq */
import React, { useState } from 'react';
import { Box, Tooltip, Grid, IconButton, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Paper, TextField, Button, Card, CardContent, Divider, useMediaQuery, useTheme } from '@mui/material';
import esArray from 'src/general_components/functionEsArray';
import { mermasUpdate } from 'src/projects/produccion/helpers/informesData';
import { ConfimDialogComponent } from 'src/general_components/ConfirmDialogComponent';
import { SnackbarMessenger } from 'src/general_components/SnackbarMessenger';
import HistoryIcon from '@mui/icons-material/History';
import ClearIcon from '@mui/icons-material/Clear';
import { SimpleDialogComponent } from 'src/general_components/SimpleDialogComponent';
import HistoricoMermas from 'src/general_components/HistoricoMermas';

const InformeDetalle = ({ data }) => {
  const formatDate = (date) => new Date(date).toLocaleDateString();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const informe = data;
  const componente = informe.componente?.sin_valores === '1' ? 'Componente no cargado' : informe.componente?.nombre;
  console.log("Informe Detalle", informe);

  const [editingData, setEditingData] = useState({});
  const [modalStateConfirm, setModalStateConfirm] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [modalStateHistorico, setMOdalStateHistorico] = useState(false);
  const [historicoMerma, setHistoricoMerma] = useState([]);

  const handleValueChange = (proceso, detalle, valorOriginal, id_prd_mermas, articulo, event) => {
    const newValue = event.target.value;
    const currentDateTime = new Date().toISOString(); // Para obtener la fecha y hora actual en formato ISO.
    setEditingData(prev => ({
      ...prev,
      [proceso]: {
        ...prev[proceso],
        [detalle]: {
          id_prd_mermas: id_prd_mermas,  // Usar el id de `articulo`
          valor_original: valorOriginal,          // Valor original
          valor_editado: newValue,                // Valor modificado
          fecha_hora: currentDateTime,            // Fecha y hora del cambio
          usuario: user_data.nombre + ", " + user_data.apellido,                       // Usuario que realizó el cambio
          id_usuario: user_data.id,
          username: user_data.username,
          id_prd_orden_produccion_detalle: articulo.id_prd_orden_produccion_detalle,
        }
      }
    }));
  };

  const handleSave = async () => {
    // Aquí podrías enviar los datos modificados al backend
    const datosUpdate = generateArrayFromData(editingData);
    const dataFinal = {
      "guardar_historico": "1",
      "prd_mermas": datosUpdate,
    }
    const response = await mermasUpdate(dataFinal);

    if (response.status === "false") {
      setMessage("No se guardar los cambios !")
      setSeverity("warning");
      setSnackbarVisible(true);
    } else {
      setMessage("Los nuevos valores de mermas se almacenaron correctamente!")
      setSeverity("success");
      setSnackbarVisible(true);
      toggleModalConfirm();
    }

  };

  const generateArrayFromData = (data) => {
    const result = [];

    // Recorrer las claves principales del objeto (maquina, almacenamiento_cliente, etc.)
    for (const proceso in data) {
      // Recorrer las claves secundarias (falla_maquina_armadora, rotas, etc.)
      for (const detalle in data[proceso]) {
        const item = data[proceso][detalle];
        // Verificar si tiene los campos id_prd_mermas y valor_editado
        if (item.id_prd_mermas && item.valor_editado) {

          // Crear el objeto con id y cantidad y añadirlo al resultado
          result.push({
            id_prd_mermas: item.id_prd_mermas,
            cantidad: item.valor_editado,
            id_prd_orden_produccion_detalle: item.id_prd_orden_produccion_detalle,
            detalle: JSON.stringify(item)
          });
        }
      }
    }

    return result;
  };

  const handleCancel = (proceso, detalle) => {
    setEditingData(prev => {
      const updatedProceso = { ...prev[proceso] };

      // Eliminar el detalle específico dentro del proceso
      delete updatedProceso[detalle];

      // Si el proceso ya no tiene detalles, eliminamos también el proceso
      if (Object.keys(updatedProceso).length === 0) {
        const { [proceso]: removed, ...rest } = prev;
        return rest;
      }

      return {
        ...prev,
        [proceso]: updatedProceso
      };
    });
  };



  const headerCellStyle = {
    backgroundColor: 'rgb(244, 246, 248)',
    color: '#637381',
    fontSize: 14,
    fontWeight: 1200,
    borderRadius: 0,
    verticalAlign: 'inherit',
    border: '1px dashed rgb(241, 243, 244)'
  };
  let user_data = JSON.parse(localStorage.getItem("siam-user-data"));
  let idPerfil = user_data.id_perfiles;

  function formatTime(hours, minutes) {
    // Asegúrate de convertir hours y minutes a números
    const hoursNum = Number(hours);
    const minutesNum = Number(minutes);
    const totalMinutes = hoursNum * 60 + minutesNum;
    const finalHours = Math.floor(totalMinutes / 60);
    const finalMinutes = totalMinutes % 60;

    return `${finalHours} horas ${finalMinutes} minutos`;
  }

  const getColor = (estado) => {
    switch (estado) {
      case 'Confirmado':
        return '#23A452'; // Verde para confirmado
      case 'Rechazado':
        return '#C70039';   // Rojo para rechazado
      default:
        return '#2350A4'; // Azul para otros casos
    }
  };

  const toggleModalConfirm = () => {
    setModalStateConfirm(!modalStateConfirm);
  };

  const handleHistorico = (proceso, detalle, merma) => {
    setHistoricoMerma(merma.historico);
    toggleModalMovimientos();
  };
  const toggleModalMovimientos = async () => {
    setMOdalStateHistorico(!modalStateHistorico);

  };
  console.log("informe detalle render", informe);

  return (
    <Box m={2}>

      {isMobile ? (
        <Card sx={{ marginBottom: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>Información General</Typography>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Typography variant="caption" color="textSecondary">Número</Typography>
                <Typography variant="body2">{informe.numero}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="caption" color="textSecondary">Fecha</Typography>
                <Typography variant="body2">{formatDate(informe.fecha)}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" color="textSecondary">Cliente</Typography>
                <Typography variant="body2">{`${informe.cliente.id_cuentas} - ${informe.cliente.nombre}`}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" color="textSecondary">Máquina</Typography>
                <Typography variant="body2">{`${informe.maquina.id} - ${informe.maquina.nombre}`}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" color="textSecondary">Estado</Typography>
                <Box>
                  <Chip
                    label={informe.estado || 'No Sincronizado'}
                    size="small"
                    style={{ fontSize: '0.75rem', height: '24px', backgroundColor: getColor(informe.estado), color: 'white' }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" color="textSecondary">Componente</Typography>
                <Typography variant="body2">{componente}</Typography>
              </Grid>
              {Array.isArray(informe.observaciones) ? (
                informe.observaciones.map((obs, index) => (
                  <Grid item xs={12} key={index}>
                    <Typography variant="caption" color="textSecondary">{`Observación ${index + 1}`}</Typography>
                    <Typography variant="body2">{obs.observaciones}</Typography>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Typography variant="caption" color="textSecondary">Observación</Typography>
                  <Typography variant="body2">{informe.observaciones?.observaciones}</Typography>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      ) : (
        <TableContainer component={Paper} style={{ marginBottom: '20px' }} sx={{ overflowX: 'auto' }}>
          <Table sx={{ minWidth: 600 }}>
            <TableBody>
              <TableRow>
                <TableCell sx={headerCellStyle}>Número</TableCell>
                <TableCell>{informe.numero}</TableCell>
                <TableCell sx={headerCellStyle}>Fecha</TableCell>
                <TableCell>{formatDate(informe.fecha)}</TableCell>
                <TableCell sx={headerCellStyle}>Estado</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={headerCellStyle}>Cliente</TableCell>
                <TableCell>{`${informe.cliente.id_cuentas} - ${informe.cliente.nombre}`}</TableCell>
                <TableCell sx={headerCellStyle}>Máquina</TableCell>
                <TableCell>{`${informe.maquina.id} - ${informe.maquina.nombre}`}</TableCell>
                <TableCell>
                  <Chip
                    label={informe.estado || 'No Sincronizado'}
                    // color={getColor(informe.estado)}
                    size="small"
                    style={{ fontSize: '0.75rem', height: '24px', backgroundColor: getColor(informe.estado), color: 'white' }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={headerCellStyle}>Componente</TableCell>
                <TableCell colSpan={8}>{componente}</TableCell>
              </TableRow>
              {/* <TableRow>
              <TableCell sx={headerCellStyle}>OT</TableCell>
              <TableCell colSpan={8}>
                {typeof informe.orden_trabajo === 'string'
                  ? informe.orden_trabajo
                  : informe.orden_trabajo && Object.keys(informe.orden_trabajo).length > 0
                    ? JSON.stringify(informe.orden_trabajo)
                    : 'Sin Orden Trabajo'}
              </TableCell>
            </TableRow> */}
              {Array.isArray(informe.observaciones) ? (
                informe.observaciones.map((obs, index) => (
                  <TableRow key={index}>
                    <TableCell sx={headerCellStyle}>{`Observación ${index + 1}`}</TableCell>
                    <TableCell colSpan={8}>{obs.observaciones}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell sx={headerCellStyle}>Observación</TableCell>
                  <TableCell colSpan={8}>{informe.observaciones?.observaciones}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )
      }

      <Typography variant="h3" component="h3">Artículos</Typography>
      {
        esArray(informe.articulos).map((articulo, index) => (
          <Box key={index} mb={4}>
            <Typography variant="h3" component="h3">{articulo.articulo.nombre}</Typography>
            {isMobile ? (
              <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="textSecondary">Orden Trabajo</Typography>
                      <Typography variant="body2">{articulo?.orden_trabajo || ""}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="textSecondary">Producción</Typography>
                      <Typography variant="body2">{articulo?.produccion?.armado || articulo?.produccion?.cantidadIngresada} unidades</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="textSecondary">Cajas Aceptadas</Typography>
                      <Typography variant="body2">
                        {articulo?.produccion?.armado ? articulo?.produccion?.armado - articulo.mermas.total : articulo?.produccion?.cantidadIngresada - articulo.mermas.total}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="textSecondary">Fecha Producción</Typography>
                      <Typography variant="body2">{formatDate(articulo.produccion.fecha)}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="caption" color="textSecondary">Hotmelt</Typography>
                      <Typography variant="body2">{articulo.hotmelt}</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ) : (
              <TableContainer component={Paper} style={{ marginBottom: '20px' }} sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Item</TableCell>
                      <TableCell>Valor</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Orden Trabajo</TableCell>
                      <TableCell>{articulo?.orden_trabajo ? articulo?.orden_trabajo : ""}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Producción</TableCell>
                      <TableCell>{articulo?.produccion?.armado ? articulo?.produccion?.armado : articulo?.produccion?.cantidadIngresada} unidades</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Cajas Aceptadas</TableCell>
                      <TableCell>
                        {articulo?.produccion?.armado ? articulo?.produccion?.armado - articulo.mermas.total : articulo?.produccion?.cantidadIngresada - articulo.mermas.total}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Fecha de Producción</TableCell>
                      <TableCell>{formatDate(articulo.produccion.fecha)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Hotmelt</TableCell>
                      <TableCell>{articulo.hotmelt}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {idPerfil !== "6" && (
              <>
                <Typography variant="h3" component="h3">Detenciones</Typography>
                {isMobile ? (
                  <Box mb={2}>
                    {Object.keys(articulo.detenciones).map(grupo => (
                      grupo !== 'total' && Object.keys(articulo.detenciones[grupo]).map(detalle => (
                        articulo.detenciones[grupo][detalle].horas >= 0 || articulo.detenciones[grupo][detalle].minutos >= 0
                          ? (
                            <Card key={`${grupo}-${detalle}`} sx={{ marginBottom: 1, backgroundColor: '#fafafa' }}>
                              <CardContent sx={{ padding: '10px !important' }}>
                                <Typography variant="caption" display="block"><strong>Grupo:</strong> {grupo}</Typography>
                                <Typography variant="body2" display="block"><strong>Detalle:</strong> {detalle}</Typography>
                                <Typography variant="body2" display="block"><strong>Tiempo:</strong> {articulo.detenciones[grupo][detalle].horas} h {articulo.detenciones[grupo][detalle].minutos} m</Typography>
                              </CardContent>
                            </Card>
                          )
                          : null
                      ))
                    ))}
                    <Card sx={{ backgroundColor: '#e0e0e0' }}>
                      <CardContent sx={{ padding: '10px !important' }}>
                        <Typography variant="subtitle2">Total Detenciones</Typography>
                        <Typography variant="body2">{articulo.detenciones.total.total_horas} h {articulo.detenciones.total.total_minutos} m</Typography>
                      </CardContent>
                    </Card>
                  </Box>
                ) : (
                  <TableContainer component={Paper} style={{ marginBottom: '20px' }} sx={{ overflowX: 'auto' }}>
                    <Table sx={{ minWidth: 600 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Grupo</TableCell>
                          <TableCell>Detalle</TableCell>
                          <TableCell>Horas</TableCell>
                          <TableCell>Minutos</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.keys(articulo.detenciones).map(grupo => (
                          grupo !== 'total' && Object.keys(articulo.detenciones[grupo]).map(detalle => (
                            articulo.detenciones[grupo][detalle].horas >= 0 || articulo.detenciones[grupo][detalle].minutos >= 0
                              ? (
                                <TableRow key={`${grupo}-${detalle}`}>
                                  <TableCell>{grupo}</TableCell>
                                  <TableCell>{detalle}</TableCell>
                                  <TableCell>{articulo.detenciones[grupo][detalle].horas}</TableCell>
                                  <TableCell>{articulo.detenciones[grupo][detalle].minutos}</TableCell>
                                </TableRow>
                              )
                              : null
                          ))
                        ))}
                        <TableRow>
                          <TableCell colSpan={2} style={{ textAlign: 'center' }}><strong>Total</strong></TableCell>
                          <TableCell>{articulo.detenciones.total.total_horas}</TableCell>
                          <TableCell>{articulo.detenciones.total.total_minutos}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </>)}

            <Typography variant="h3" component="h3">Mermas</Typography>
            {isMobile ? (
              <Box mb={2}>
                {Object.keys(articulo.mermas)
                  .filter(proceso =>
                    idPerfil === "6" ? ['fabricacion', 'transporte'].includes(proceso) : true
                  )
                  .map(proceso => (
                    proceso !== 'total' && Object.keys(articulo.mermas[proceso]).map(detalle => {
                      const key = `${proceso}-${detalle}`;
                      const { valor_editado } = (editingData[proceso] && editingData[proceso][detalle])
                        ? editingData[proceso][detalle]
                        : { valor_original: articulo.mermas[proceso][detalle].val, valor_editado: articulo.mermas[proceso][detalle].val };

                      if (articulo.mermas[proceso][detalle].val <= 0) return null;

                      return (
                        <Card key={key} sx={{ marginBottom: 1 }}>
                          <CardContent>
                            <Typography variant="subtitle2" color="primary">{proceso}</Typography>
                            <Typography variant="body1" gutterBottom>{detalle}</Typography>

                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={6}>
                                <Typography variant="caption" display="block">Valor</Typography>
                                {idPerfil === "2" ? (
                                  <TextField
                                    type="number"
                                    value={valor_editado}
                                    onChange={event => handleValueChange(proceso, detalle, articulo.mermas[proceso][detalle].val,
                                      articulo.mermas[proceso][detalle].id_prd_mermas, articulo, event)}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                  />
                                ) : (
                                  <Typography variant="h6">{articulo.mermas[proceso][detalle].val}</Typography>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="caption" display="block">Imagen</Typography>
                                {articulo.mermas[proceso][detalle].pict && typeof articulo.mermas[proceso][detalle].pict === 'string' && articulo.mermas[proceso][detalle].pict !== ""
                                  ? (
                                    <img
                                      src={articulo.mermas[proceso][detalle].pict}
                                      alt={`Imagen de ${detalle}`}
                                      style={{ maxWidth: '100%', maxHeight: '60px', objectFit: 'contain' }}
                                    />
                                  )
                                  : <Typography variant="caption" color="textSecondary">No disponible</Typography>}
                              </Grid>
                            </Grid>
                          </CardContent>
                          {idPerfil === "2" && (
                            <Grid container justifyContent="flex-end" sx={{ p: 1, gap: 1 }}>
                              <Tooltip title="Cancelar">
                                <IconButton
                                  onClick={() => handleCancel(proceso, detalle)}
                                  color="error"
                                  size="small"
                                  sx={{ backgroundColor: '#ffebee' }}
                                >
                                  <ClearIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Histórico">
                                <IconButton
                                  onClick={() => handleHistorico(proceso, detalle, articulo.mermas[proceso][detalle])}
                                  color="primary"
                                  size="small"
                                  sx={{ backgroundColor: '#e3f2fd' }}
                                >
                                  <HistoryIcon />
                                </IconButton>
                              </Tooltip>
                            </Grid>
                          )}
                        </Card>
                      );
                    })
                  ))}
                <Card sx={{ backgroundColor: '#e0e0e0', mt: 1 }}>
                  <CardContent sx={{ padding: '10px !important' }}>
                    <Typography variant="subtitle2">Total Mermas: {articulo.mermas.total}</Typography>
                  </CardContent>
                </Card>
                {idPerfil === "2" && (
                  <Box mt={2}>
                    <Button onClick={toggleModalConfirm} variant="contained" color="primary" fullWidth>
                      Guardar Cambios
                    </Button>
                  </Box>
                )}
              </Box>
            ) : (
              <TableContainer component={Paper} style={{ marginBottom: '20px' }} sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Proceso</TableCell>
                      <TableCell>Detalle</TableCell>
                      <TableCell>Valor</TableCell>
                      <TableCell>Imagen</TableCell>
                      {idPerfil === "2" && <TableCell>Acciones</TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(articulo.mermas)
                      .filter(proceso =>
                        idPerfil === "6" ? ['fabricacion', 'transporte'].includes(proceso) : true
                      )
                      .map(proceso => (
                        proceso !== 'total' && Object.keys(articulo.mermas[proceso]).map(detalle => {
                          const key = `${proceso}-${detalle}`;
                          const { valor_editado } = (editingData[proceso] && editingData[proceso][detalle])
                            ? editingData[proceso][detalle]
                            : { valor_original: articulo.mermas[proceso][detalle].val, valor_editado: articulo.mermas[proceso][detalle].val };

                          if (articulo.mermas[proceso][detalle].val <= 0) return null;

                          return (
                            <TableRow key={key}>
                              <TableCell>{proceso}</TableCell>
                              <TableCell>{detalle}</TableCell>
                              <TableCell>
                                {idPerfil === "2" ? (
                                  <TextField
                                    type="number"
                                    value={valor_editado}
                                    onChange={event => handleValueChange(proceso, detalle, articulo.mermas[proceso][detalle].val,
                                      articulo.mermas[proceso][detalle].id_prd_mermas, articulo, event)}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                  />
                                ) : (
                                  articulo.mermas[proceso][detalle].val
                                )}
                              </TableCell>
                              <TableCell >
                                {articulo.mermas[proceso][detalle].pict && typeof articulo.mermas[proceso][detalle].pict === 'string' && articulo.mermas[proceso][detalle].pict !== ""
                                  ? (
                                    <img
                                      src={articulo.mermas[proceso][detalle].pict}
                                      alt={`Imagen de ${detalle}`}
                                      style={{ maxWidth: '100px', maxHeight: '100px' }}
                                    />
                                  )
                                  : 'No hay imagen disponible'}
                              </TableCell>
                              {idPerfil === "2" && (
                                <TableCell>
                                  <Grid sx={{
                                    display: 'flex',           // Activa el modelo de caja flexible
                                    justifyContent: 'center',   // Centra los elementos horizontalmente
                                    alignItems: 'center',       // Centra los elementos verticalmente
                                    gap: '10px',                // Espaciado entre los botones
                                  }}>
                                    <Tooltip title="Cancelar" placement="top">
                                      <IconButton
                                        onClick={() => handleCancel(proceso, detalle)}
                                        color="error"
                                        sx={{
                                          backgroundColor: '#d32f2f', // Color de fondo rojo
                                          '&:hover': {
                                            backgroundColor: '#b71c1c', // Cambio de color en hover
                                          },
                                          borderRadius: '4px', // Borde ligeramente redondeado
                                          padding: '10px', // Espaciado interno
                                          display: 'flex', // Asegura que el icono esté centrado
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          width: '30px', // Ancho fijo para que sea cuadrado
                                          height: '30px', // Altura fija para que sea cuadrado
                                        }}
                                      >
                                        <ClearIcon sx={{ fontSize: '24px', color: '#fff' }} />
                                      </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Histórico" placement="top">
                                      <IconButton
                                        onClick={() => handleHistorico(proceso, detalle, articulo.mermas[proceso][detalle])}
                                        color="primary"
                                        sx={{
                                          backgroundColor: '#1976d2', // Color de fondo azul
                                          '&:hover': {
                                            backgroundColor: '#1565c0', // Cambio de color en hover
                                          },
                                          borderRadius: '4px', // Borde ligeramente redondeado
                                          padding: '10px', // Espaciado interno
                                          display: 'flex', // Asegura que el icono esté centrado
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          width: '30px', // Ancho fijo para que sea cuadrado
                                          height: '30px', // Altura fija para que sea cuadrado
                                        }}
                                      >
                                        <HistoryIcon sx={{ fontSize: '24px', color: '#fff' }} />
                                      </IconButton>
                                    </Tooltip>
                                  </Grid>

                                </TableCell>
                              )}

                            </TableRow>
                          );
                        })
                      ))}
                    <TableRow>
                      <TableCell colSpan={3} style={{ textAlign: 'center' }}><strong>Total</strong></TableCell>
                      <TableCell>{articulo.mermas.total}</TableCell>
                    </TableRow>
                    {idPerfil === "2" && (
                      <TableRow>
                        <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                          <Button onClick={toggleModalConfirm} variant="contained" color="primary">
                            Guardar Cambios
                          </Button>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}



            <Typography variant="h3" component="h3">Control Desgarre</Typography>
            {isMobile ? (
              <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                  {articulo.control_desgarre ? (
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={6}>
                        <Typography variant="caption" display="block">Valor</Typography>
                        <Typography variant="body1">{articulo.control_desgarre.val}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="caption" display="block">Imagen</Typography>
                        {articulo.control_desgarre.pict && articulo.control_desgarre.pict !== "" ? (
                          <img
                            src={articulo.control_desgarre.pict}
                            alt="Imagen de Control Desgarre"
                            style={{ maxWidth: '100%', maxHeight: '100px', objectFit: 'contain' }}
                          />
                        ) : (
                          <Typography variant="caption" color="textSecondary">No disponible</Typography>
                        )}
                      </Grid>
                    </Grid>
                  ) : (
                    <Typography variant="body2" color="textSecondary">No se encontraron datos.</Typography>
                  )}
                </CardContent>
              </Card>
            ) : (
              <TableContainer component={Paper} style={{ marginBottom: '20px' }} sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Valor</TableCell>
                      <TableCell>Imagen</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {articulo.control_desgarre && (
                      <TableRow>
                        <TableCell>{articulo.control_desgarre.val}</TableCell>
                        <TableCell className="centered">
                          {articulo.control_desgarre.pict && articulo.control_desgarre.pict !== ""
                            ? (
                              <img
                                src={articulo.control_desgarre.pict}
                                alt="Imagen de Control Desgarre"
                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                              />
                            )
                            : 'No hay imagen disponible'}
                        </TableCell>
                      </TableRow>
                    )}
                    {!articulo.control_desgarre && (
                      <TableRow>
                        <TableCell className="centered" colSpan={2}>No se encontraron datos.</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Typography variant="h3" component="h3">Fruta</Typography>
            {isMobile ? (
              <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                  <Typography variant="caption" color="textSecondary">Nombre</Typography>
                  <Typography variant="body1">{articulo.fruta ? articulo.fruta.nombre : 'No especificado'}</Typography>
                </CardContent>
              </Card>
            ) : (
              <TableContainer component={Paper} style={{ marginBottom: '20px' }} sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {articulo.fruta && (
                      <TableRow>
                        <TableCell>{articulo.fruta.nombre}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Typography variant="h3" component="h3">Tipo Armado</Typography>
            {isMobile ? (
              <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                  <Typography variant="caption" color="textSecondary">Nombre</Typography>
                  <Typography variant="body1">{articulo.tipo_armado ? articulo.tipo_armado.nombre : 'No especificado'}</Typography>
                </CardContent>
              </Card>
            ) : (
              <TableContainer component={Paper} style={{ marginBottom: '20px' }} sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {articulo.tipo_armado && (
                      <TableRow>
                        <TableCell>{articulo.tipo_armado.nombre}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

          </Box>
        ))
      }

      <Typography variant="h3" component="h3">Totales Generales</Typography>
      {
        isMobile ? (
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography variant="caption" color="textSecondary">Total Detenciones</Typography>
                  <Typography variant="body2">{formatTime(informe.total_detenciones.horas, informe.total_detenciones.minutos)}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" color="textSecondary">Total Hotmelt</Typography>
                  <Typography variant="body2">{informe.total_hotmelt}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" color="textSecondary">Total Mermas</Typography>
                  <Typography variant="body2">{informe.total_mermas}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" color="textSecondary">Total Producción</Typography>
                  <Typography variant="body2">{informe.total_produccion}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="caption" color="textSecondary">Total Cajas Aceptadas</Typography>
                  <Typography variant="body1" fontWeight="bold">{informe.total_produccion - informe.total_mermas}</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ) : (
          <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
            <Table sx={{ minWidth: 600 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Item</TableCell>
                  <TableCell>Valor</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>Total Detenciones</TableCell>
                  <TableCell>
                    {formatTime(informe.total_detenciones.horas, informe.total_detenciones.minutos)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Total Hotmelt</TableCell>
                  <TableCell>{informe.total_hotmelt}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Total Mermas</TableCell>
                  <TableCell>{informe.total_mermas}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Total Producción</TableCell>
                  <TableCell>{informe.total_produccion}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Total Cajas Aceptadas</TableCell>
                  <TableCell>{informe.total_produccion - informe.total_mermas}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )
      }
      <ConfimDialogComponent
        maxWidth={'xs'}
        open={modalStateConfirm}
        modalName={"Aviso"}
        mensaje={
          "Esta seguro que desea modificar los valores de mermas?"
        }
        handleConfirm={handleSave}
        handleClose={toggleModalConfirm}
      />
      <SimpleDialogComponent
        open={modalStateHistorico}
        modalName={"Historico"}
        child={<HistoricoMermas data={historicoMerma} />}
        setPushData={toggleModalMovimientos}
        handleClose={toggleModalMovimientos}
        buttonEnviar={false}
        buttonCancelar={true}
      />
      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => {
          setSnackbarVisible(false);
        }}
      />
    </Box >
  );
};

export default InformeDetalle;
